import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class ForecastCampaignService {
	constructor(private http: HttpClient) {}

	getCampaigns(): any {
		return this.http.get(`${environment.api}forecast/get_all_campaigns`);
	}
}

@Injectable({
	providedIn: 'root',
})
export class ForecastCampaignTypeService {
	constructor(private http: HttpClient) {}

	getCampaignTypes(): any {
		return this.http.get(`${environment.api}forecast/get_campaign_types`);
	}
}

@Injectable({
	providedIn: 'root',
})
export class ForecastCampaignPeriods {
	constructor(private http: HttpClient) {}

	getCampaignPeriods(): any {
		return this.http.get(`${environment.api}forecast/get_campaign_periods`);
	}
}
